import React from 'react';
import download from '../../utils/download';
import PopoverOnClick from '../../../components/PopoverOnClick';
import FilesHelpers from '../../../helpers/FileHelpers';
import TooltipOnHover from '../../../components/TooltipOnHover';
import { FilePDFIcon, ExpandIcon, ExternalLinkIcon, MoreIcon, EyeIcon, DeleteIcon } from '../../../components/Icons';
export default function Header(_ref) {
  var url = _ref.url,
      name = _ref.name,
      size = _ref.size,
      onShowPreview = _ref.onShowPreview,
      toggleLightbox = _ref.toggleLightbox,
      onDelete = _ref.onDelete,
      hidePreview = _ref.hidePreview,
      isMobile = _ref.isMobile,
      readOnly = _ref.readOnly;
  var ref = React.useRef();

  var PopoverContent = function PopoverContent() {
    return React.createElement("div", {
      className: "flexbox flexbox-column shadow-normal radius-normal background-white",
      style: {
        width: 172
      }
    }, hidePreview && React.createElement("div", {
      className: "padding-medium flexbox flexbox-align-center background-shade-50-on-hover pointer",
      onClick: function onClick(e) {
        onShowPreview();
        ref.current.toggle(e);
      }
    }, React.createElement(EyeIcon, {
      size: 16,
      className: "shade-20 margin-right-normal"
    }), React.createElement("div", {
      className: "shade-10 font-weight-medium"
    }, "Embed preview")), React.createElement("div", {
      className: "padding-medium flexbox flexbox-align-center background-shade-50-on-hover pointer",
      onClick: function onClick() {
        return download(url);
      }
    }, React.createElement(ExternalLinkIcon, {
      size: 16,
      className: "shade-20 margin-right-normal"
    }), React.createElement("div", {
      className: "shade-10 font-weight-medium"
    }, "Open Original")), React.createElement("div", {
      className: "padding-medium flexbox flexbox-align-center background-shade-50-on-hover pointer",
      onClick: onDelete
    }, React.createElement(DeleteIcon, {
      size: 16,
      className: "shade-20  margin-right-normal"
    }), React.createElement("div", {
      className: "shade-10 font-weight-medium"
    }, "Delete")));
  };

  var onMobileClick = function onMobileClick() {
    if (isMobile) {
      download(url);
    }
  };

  return React.createElement("div", {
    contentEditable: false,
    className: "padding-large flexbox flexbox-space-between flexbox-align-center line-height-normal",
    onClick: onMobileClick
  }, React.createElement("div", {
    className: "flexbox"
  }, React.createElement("div", {
    className: "margin-right-normal"
  }, React.createElement(FilePDFIcon, {
    size: 16,
    className: "red"
  })), React.createElement("div", {
    className: "flexbox flexbox-column"
  }, React.createElement("div", {
    className: "bold shade-05 margin-bottom-smaller"
  }, name), React.createElement("div", {
    className: "shade-20 font-weight-medium font-size-normal"
  }, "PDF document ", FilesHelpers.bytesToSize(size)))), !isMobile && React.createElement("div", {
    className: "shade-20 flexbox flexbox-align-center"
  }, React.createElement(TooltipOnHover, {
    placement: "bottom",
    tooltipContent: 'Expand',
    withArrow: false
  }, React.createElement(ExpandIcon, {
    size: 24,
    className: "padding-smaller background-shade-50-on-hover margin-right-medium pointer radius-normal",
    onClick: toggleLightbox
  })), !readOnly && React.createElement(PopoverOnClick, {
    ref: ref,
    position: "bottom",
    content: PopoverContent
  }, React.createElement(MoreIcon, {
    size: 24,
    className: "padding-smaller background-shade-50-on-hover pointer radius-normal rotate-clockwise"
  }))));
}